const user = {
  state: {
    userDetal: {},
    accessToken: "",
    appToken: "",
    loginInfo: {}
  },

  mutations: {
    SET_ACCESS_TOKEN: (state, token) => {
      state.accessToken = token;
    },
    SET_APP_TOKEN: (state, token) => {
      state.appToken = token;
    },
    SET_USER_DETAL: (state, obj) => {
      state.userDetal = obj;
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId;
    },
    SET_LOGIN_INFO: (state, obj) => {
      state.loginInfo = obj;
    }
  },

  actions: {
    setLoginInfo({ commit }, response) {
      commit("SET_LOGIN_INFO", response);
    }
  },
  getters: {
    getLoginInfo: state => {
      return state.loginInfo;
    }
  }
};

export default user;
